import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import Icon from "@alboompro/boom-components/general/icon";
import ModalSettings from "@alboom/custom-page-settings/Modal";
import { setPage } from "store/actions/pageActions";
import { PageSettingsContent } from "./styles";

class PageSettings extends Component {
  state = {
    visible: false,
  };

  handleModalVisibility = (e) => {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  };

  handleUpdate = (page, closeModal = true) => {
    const { setPage } = this.props;
    const iframe = document.querySelector("iframe.editor-frame");
    if (iframe) {
      const iframeBody = iframe.contentWindow.document.body;
      if (page.landing_page) {
        iframeBody.classList.add("cp-lp-mode");
      } else {
        iframeBody.classList.remove("cp-lp-mode");
      }
    }
    setPage(page);
    if (closeModal) {
      this.setState({ visible: false });
    }
  };

  render() {
    const { page, locale } = this.props;
    const { visible } = this.state;

    return (
      <Fragment>
        <PageSettingsContent onClick={this.handleModalVisibility}>
          <Icon
            kind="bold"
            group="interface-essential"
            category="settings"
            file="cog-double-3.svg"
            size="17"
            color="#4F4F4F"
          />
          {I18n.t("header.pageSettings.button")}
        </PageSettingsContent>
        <ModalSettings
          modalStatus={visible}
          onClose={this.handleUpdate}
          onUpdate={(page) => {
            this.handleUpdate(page, false);
          }}
          language={locale}
          pageId={page.id}
        />
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  setPage,
};

const mapStateToProps = (state) => {
  return {
    locale: state.i18n.locale,
    page: state.page,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSettings);
